import { axiosInstance } from ".."

const projectAttachementCategories = async () =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/pm/categories`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default projectAttachementCategories;